//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {
    angular.module('container.widgets').directive('srsngDisplayFooterMessage', displayFooterMessage);

    function displayFooterMessage($rootScope, $timeout,$sce) {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/widgets/displayFooterMessage/displayFooterMessage.html',
            controllerAs: 'vm',
            controller: controller,
            scope: {
                footerDetails: "="
            },
            link: link
        };

        function link($scope) {
            let timer;
            $scope.close = close;
            $scope.closeIcon = '/container/ui/assets/img/icons/system-icons-16x16/system-ic-cross-16x16.svg';
            $scope.successIcon = "/container/ui/assets/img/icons/state-icons-18x18/state-ic-done-18x18.svg";
            $scope.errorIcon = "/container/ui/assets/img/icons/state-icons-18x18/state-ic-error-18x18.svg";
            $scope.warningIcon = "/container/ui/assets/img/icons/state-icons-18x18/state-ic-warning-18x18.svg";
            $scope.displayFooter = $scope.footerDetails.display ? $scope.footerDetails.display : false;
            checkHtmlContent();
            $scope.$watch('footerDetails', function (newValue, oldValue) {
                checkHtmlContent();
                if (newValue) {
                    $scope.displayFooter = true;
                    if ($scope.footerDetails.autoClose) {
                        if (timer) {
                            $timeout.cancel(timer);
                        }
                        timer = $timeout(function () {
                            $scope.close();
                        }, 10000);
                    }
                }
            }, true);

            function close() {
                $scope.displayFooter = false;
                $scope.footerDetails.display = false;
            }

            function checkHtmlContent() {
                const parser = new DOMParser();
                const doc = parser.parseFromString($scope.footerDetails.message, 'text/html');

                $scope.isHtmlContent = doc.body.innerHTML !== doc.body.textContent;
                if($scope.isHtmlContent)
                {
                    $scope.trustedMessage = $sce.trustAsHtml($scope.footerDetails.message);
                }
            }
        }

        function controller($scope, $rootScope, $timeout) {
            // this is intentional override
        }
    }

})();